import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { withRouter } from 'react-router-dom'
import {Paper,Grid,Switch} from '@material-ui/core'

import { AgGridReact } from 'ag-grid-react';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise'

import callAccountsApi from '../data-provider'

import ActionCellRenderer from '../components/action-cell-renderer'
import getGridConfig from './grid-config-clients'
import Menu from './menu'
import ClientForm from './client-form'

const styles = theme => ({
  paper: {
    overflowX: 'auto',
    backgroundColor : '#fff',
    padding : 10,
    margin : 'auto',
    position : 'fixed',
    top : 300,
    bottom : 20,
    left : 20,
    right : 20,
  },
})

class ManageClients extends Component {

  constructor(props, context) {
    super(props, context)
    this.state = {clients:[],client:null,showInactive:false}
  }

  componentDidMount() {
    this.getClients()
  }

  getClients = async () => {
    let clients = await callAccountsApi("clients","getClients")
    this.setState({clients})
  }

  actionClickHandler = (action,client) => {
    switch(action)
    {
      case "new" : return this.openForm({})
      case "edit" : return this.openForm(client)
      default: {}
    }
  }

  onRowDoubleClicked = row => {
    this.openForm(row.data)
  }
  
  openForm = client => {
    this.setState({client})
  }

  closeForm = refresh => {
    this.setState({client:null})
    if (refresh)
    {
      this.getClients()
    }
  }

  toggleInactive = () => {
    let showInactive = !this.state.showInactive
    this.setState({showInactive})
  }

  render() {
    const { classes } = this.props

    let columnDefs = getGridConfig(this.actionClickHandler)
    let clients = this.state.clients.filter(c => c.active || this.state.showInactive)

    return (
      <React.Fragment>
          
        <Menu page="clients"/>

        <span style={{float:"right",color:'#fff'}}>
          <Grid component="label" container item alignItems="center" spacing={1}>
            <Grid item>Active Clients</Grid>
            <Grid item>
              <Switch
                checked={this.state.showInactive}
                onChange={this.toggleInactive}
                color="primary"
              />
            </Grid>
            <Grid item>All Clients</Grid>
          </Grid>
        </span>

        <Paper className={classes.paper}>
          <div className="ag-theme-alpine" style={ {width: '100%' }}>
            <AgGridReact rowData={clients} columnDefs={columnDefs} domLayout='autoHeight' frameworkComponents={{actionCellRenderer : ActionCellRenderer}} onRowDoubleClicked={this.onRowDoubleClicked}/>
          </div>
        </Paper>

        <ClientForm open={this.state.client !== null} close={this.closeForm} client={this.state.client} />

      </React.Fragment>
    )
  }
}

export default withRouter(withStyles(styles)(ManageClients))
